import React, { useState, useEffect } from 'react';
import './UsageAnalyticsTab.css';
import { Button, Drawer, Input, Table, Form, Select } from 'antd';
import { RiDatabase2Line } from 'react-icons/ri';
import ViewAccessRequest from './ViewAccessRequest/ViewAccessRequest';
import { useDispatch, useSelector } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import { SettingsUserAnalyticsActionHandler } from '../../../../Redux/Actions/user/SettingsUserAnalyticsActions';

const info6 = '/assets/info-6.svg';
const SearchIcon = '/assets/SearchIcon.svg';
const vuesaxlinearusercirlceadd = '/assets/vuesaxlinearusercirlceadd.svg';
const UsageAnalyticsTab = () => {
    const SideClose = '/assets/ModalClose.svg';
    let dispatch = useDispatch();
    const settingsusageanalyticsData = useSelector(
        (state) =>
            state?.SettingsUserAnalyticsData?.settings_user_analytics_data
    );
    const [searchValue, setSearchValue] = useState(null);
    const [isDrawerVisible, setDrawerVisible] = useState(false);
    const [isAddCreditsOpen, setIsAddCreditsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [setusageanalytics, setUsageAnalytics] = useState('today');
    const [sortedInfo, setSortedInfo] = useState(null);
    const [isViewAccessRequestOpen, setIsViewAccessRequestOpen] =
        useState(false);
    const fetchData = async () => {
        try {
            dispatch(
                SettingsUserAnalyticsActionHandler(
                    '',
                    '',
                    setusageanalytics,
                    currentPage
                )
            );
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(
            SettingsUserAnalyticsActionHandler('', '', setusageanalytics, page)
        );
    };
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) =>
                `${a.first_name} ${a.last_name}`.localeCompare(
                    `${b.first_name} ${b.last_name}`
                ),
            render: (text, record) =>
                `${record.first_name} ${record.last_name}`,
        },
        { title: 'Roll Name', dataIndex: 'role_name', key: 'role_name' },
        {
            title: 'Credit Used',
            dataIndex: 'action_runs_count',
            key: 'action_runs_count',
        },
        {
            title: 'QA Created',
            dataIndex: 'quick_actions_count',
            key: 'quick_actions_count',
        },
        { title: 'Time Saved', dataIndex: 'time_saved', key: 'time_saved' },
    ];

    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSearch = debounce((e) => {
        let value = e.target.value;
        let encodedValue = encodeURIComponent(value);
        if (encodedValue?.length) {
            setSearchValue(encodedValue);
        }
        if (!encodedValue.length) {
            dispatch(
                SettingsUserAnalyticsActionHandler(
                    '',
                    '',
                    setusageanalytics,
                    currentPage
                )
            );
        }
    }, 1000);

    const AddCreditsOverlay = () => {
        setIsAddCreditsOpen(!isAddCreditsOpen);
    };

    const ViewAccessRequestOverlay = () => {
        setIsViewAccessRequestOpen(!isViewAccessRequestOpen);
    };
    const OpenAddWorkspace = () => {
        setDrawerVisible(true);
    };
    const handleDrawerClose = () => {
        setDrawerVisible(false);
    };

    useEffect(() => {
        if (searchValue?.length > 3) {
            dispatch(
                SettingsUserAnalyticsActionHandler(
                    searchValue,
                    '',
                    setusageanalytics,
                    currentPage
                )
            );
        }
    }, [searchValue]);

    useEffect(() => {
        fetchData();
    }, []);
    const handleAnalyticsClick = (value) => {
        setUsageAnalytics(value);
        dispatch(
            SettingsUserAnalyticsActionHandler('', '', value, currentPage)
        );
    };

    return (
        <>
            <div>
                <div className='workspaceanalytics-container'>
                    <div className='workspaceanalytics-main_1'>
                        <div className='relative search-container'>
                            <input
                                type='text'
                                placeholder='Search user here'
                                className='workspaceanalytics-search-from-logs'
                                onChange={(e) => handleSearch(e)}
                            />
                            <img
                                src={SearchIcon}
                                alt=''
                                className='search-icon'
                            />
                        </div>
                        <div className='workspaceanalytics-main'>
                            <div className='usage-analytics-main'>
                                <div>
                                    <div className='rectangle-parent9'>
                                        <button
                                            className={
                                                setusageanalytics === 'today'
                                                    ? `butttonusageanalytics activeusageanalytics`
                                                    : `butttonusageanalytics`
                                            }
                                            onClick={(e) =>
                                                handleAnalyticsClick('today')
                                            }>
                                            Today
                                        </button>
                                        <button
                                            className={
                                                setusageanalytics === 'week'
                                                    ? `butttonusageanalytics activeusageanalytics`
                                                    : `butttonusageanalytics`
                                            }
                                            onClick={(e) =>
                                                handleAnalyticsClick('week')
                                            }>
                                            Week
                                        </button>
                                        <button
                                            className={
                                                setusageanalytics === 'month'
                                                    ? `butttonusageanalytics activeusageanalytics`
                                                    : `butttonusageanalytics`
                                            }
                                            onClick={(e) =>
                                                handleAnalyticsClick('month')
                                            }>
                                            Month
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={settingsusageanalyticsData?.data?.data}
                        size='middle'
                        className='mytable'
                        pagination={{
                            pageSize:
                                settingsusageanalyticsData?.data?.per_page,
                            total: settingsusageanalyticsData?.data?.total,
                            showSizeChanger: false,
                            onChange: handlePageChange,
                        }}
                        onChange={(pagination, filters, sorter) =>
                            setSortedInfo(sorter)
                        }
                    />
                </div>

                <Drawer
                    placement='right'
                    closable={false}
                    onClose={AddCreditsOverlay}
                    open={isAddCreditsOpen}
                    key='right'
                    width={'40%'}>
                    <img
                        className='workspaceanalytics-sideClose'
                        src={SideClose}
                        alt=''
                        onClick={AddCreditsOverlay}
                    />
                    <div className='side-modal-div'>
                        <h3>Credits Request</h3>
                    </div>
                    <div className='workspaceanalytics-input'>
                        <div className='workspaceanalytics-1'>
                            <label>
                                User: <b>George Clark</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Requested Credits: <b>200</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Workspace: <b>Marketing</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Date of Request: <b>16th Oct 2023</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmt-20'>
                            <hr />
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmb-20'>
                            <label>
                                Remaining Credits in Workspace: <b>100</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Text Field for Note (Optional)
                                <div className='tooltip'>
                                    <img src={info6} alt='info6' />
                                    <span className='tooltiptext'>
                                        Use this optional note to explain your
                                        decision when approving or declining the
                                        request.
                                    </span>
                                </div>
                            </label>
                            <Input />
                        </div>
                        <div className='workspaceanalytics-3'>
                            <label>Credits:</label>
                            <Input placeholder='50' />
                            <Button className='workspaceanalytics-buy-more-credits'>
                                Buy more Credits
                            </Button>
                            <Button className='workspaceanalytics-decline'>
                                Decline
                            </Button>
                        </div>
                    </div>
                </Drawer>
                {isViewAccessRequestOpen ? (
                    <ViewAccessRequest
                        isViewAccessRequestOpen={isViewAccessRequestOpen}
                        ViewAccessRequestOverlay={ViewAccessRequestOverlay}
                    />
                ) : null}
                <Drawer
                    placement='right'
                    closable={false}
                    onClose={ViewAccessRequest}
                    open={isViewAccessRequestOpen}
                    key='right'
                    width={'40%'}>
                    <img
                        className='workspaceanalytics-sideClose'
                        src={SideClose}
                        alt=''
                        onClick={ViewAccessRequest}
                    />
                    <div className='side-modal-div'>
                        <h3>Credits Request</h3>
                    </div>
                    <div className='workspaceanalytics-input'>
                        <div className='workspaceanalytics-1'>
                            <label>
                                User: <b>George Clark</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Requested Credits: <b>200</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Workspace: <b>Marketing</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Date of Request: <b>16th Oct 2023</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmt-20'>
                            <hr />
                        </div>
                        <div className='workspaceanalytics-1 workspaceanalyticsmb-20'>
                            <label>
                                Remaining Credits in Workspace: <b>100</b>
                            </label>
                        </div>
                        <div className='workspaceanalytics-1'>
                            <label>
                                Text Field for Note (Optional)
                                <div className='tooltip'>
                                    <img src={info6} alt='info6' />
                                    <span className='tooltiptext'>
                                        Use this optional note to explain your
                                        decision when approving or declining the
                                        request.
                                    </span>
                                </div>
                            </label>
                            <Input />
                        </div>
                        <div className='workspaceanalytics-3'>
                            <label>Credits:</label>
                            <Input placeholder='50' />
                            <Button className='workspaceanalytics-buy-more-credits'>
                                Buy more Credits
                            </Button>
                            <Button className='workspaceanalytics-decline'>
                                Decline
                            </Button>
                        </div>
                    </div>
                </Drawer>

                <Drawer
                    title='Add Workspace'
                    placement='right'
                    closable={true}
                    onClose={handleDrawerClose}
                    visible={isDrawerVisible}
                    width={500}>
                    {/* Add your form for editing here */}
                    <Form>
                        <div className='new-btn'>
                            <h2>Add Workspace</h2>
                            <Button
                                className='close-btn'
                                type='text'
                                placement='right'
                                shape='circle'
                                icon={<CloseOutlined />}
                                size='large'
                                onClick={handleDrawerClose}
                            />
                        </div>
                        <div className='faq-input'>
                            <label>Select name of client</label>
                            <Select
                                showSearch
                                style={{ width: '60%' }}
                                placeholder='QuickAction'
                                optionFilterProp='children'
                                onChange={() => {
                                    /* handle topic change */
                                }}
                                options={[
                                    {
                                        value: 'jack',
                                        label: 'Jack',
                                    },
                                    {
                                        value: 'lucy',
                                        label: 'Lucy',
                                    },
                                    {
                                        value: 'tom',
                                        label: 'Tom',
                                    },
                                ]}
                            />
                        </div>

                        <div className='faq-input'>
                            <label>Select number of workspace</label>
                            <Select
                                showSearch
                                style={{ width: '60%' }}
                                placeholder='QuickAction'
                                optionFilterProp='children'
                                onChange={() => {
                                    /* handle topic change */
                                }}
                                options={[
                                    {
                                        value: 'jack',
                                        label: 'Jack',
                                    },
                                    {
                                        value: 'lucy',
                                        label: 'Lucy',
                                    },
                                    {
                                        value: 'tom',
                                        label: 'Tom',
                                    },
                                ]}
                            />
                        </div>
                        <div className='video-input-field2'>
                            <label> 1st Workspace name</label>
                            <Input placeholder='Workspace name goes here' />
                        </div>
                        <div className='video-input-field2'>
                            <label> 2nd Workspace name</label>
                            <Input placeholder='Workspace name goes here' />
                        </div>
                        <div className='video-input-field2'>
                            <label> 3rd Workspace name</label>
                            <Input placeholder='Workspace name goes here' />
                        </div>
                        <div className='faq-input'>
                            <label>Owner name</label>
                            <Select
                                showSearch
                                style={{ width: '60%' }}
                                placeholder='Select'
                                optionFilterProp='children'
                                onChange={() => {
                                    /* handle topic change */
                                }}
                                options={[
                                    {
                                        value: 'jack',
                                        label: 'Jack',
                                    },
                                    {
                                        value: 'lucy',
                                        label: 'Lucy',
                                    },
                                    {
                                        value: 'tom',
                                        label: 'Tom',
                                    },
                                ]}
                            />
                        </div>
                        <div className='upload'>
                            <button className='upload-button'>
                                Add Workspace
                            </button>
                        </div>
                    </Form>
                </Drawer>
            </div>
        </>
    );
};
export default UsageAnalyticsTab;
